import { CreditCard } from 'lucide-react';
import { cn } from '@/utils/merge';
// import { RulerDimensionLine } from 'lucide-react';
// import { ReceiptEuro } from 'lucide-react';
// import { HandCoins } from 'lucide-react';

// const variants = {
// 	distance: 'bg-green-50 text-[rgb(62,145,72)]! border-1 border-green-300',
// 	price: 'bg-amber-50 text-[rgb(200,160,50)]! border-1 border-amber-300',
// 	fee: 'bg-red-50 text-[rgb(240,64,84)]! border-1 border-red-300',
// };

// const icons = {
// 	distance: <RulerDimensionLine size={11.5} color={'rgb(62,145,72)'} />,
// 	price: <ReceiptEuro size={11.5} color={'rgb(200,160,50)'} />,
// 	fee: <HandCoins size={11.5} color={'rgb(240,64,84)'} />,
// };

const labels = {
	distance: 'Χ',
	price: 'Τ',
	fee: 'Π',
	shopFee: 'Χρ',
	tip: 'Tip',
};
export const ChipOrder = ({ variant, isCard, value }) => {
	// const className = variants[variant];
	// const icon = icons[variant];
	const label = labels[variant];
	return (
		<div
			className={cn(
				'flex h-5.5 flex-row items-center gap-x-1 rounded-sm border-1 border-yellow-400 bg-yellow-200/20 px-1 text-[0.65rem] text-yellow-700!',
				'min-[1020px]:h-6.5 min-[1020px]:px-2 min-[1020px]:text-[0.75rem]',
				// className,
			)}
		>
			<div className='!text-inherit'>{label}</div>

			<div className='flex flex-row items-center gap-x-1 !text-inherit'>
				{value} {isCard && <CreditCard size={14} />}
			</div>
		</div>
	);
};
